import React, {useEffect} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import { withRouter } from "react-router-dom";

import WithOverlay from "../../popups/withOverlayHoc";
import {setLookOverlayOpened} from "../../../actions/lookFunctions";
import {LOOK_OVERLAYS} from "../core/constants";
import {IS_PRODUCT_JOURNEY} from "../../../config";
import LookLoadingBar from "./lookLoadingBar";
import {renderErrorPopup} from "../../../api/api-popups";
import {GROHE_POST_MESSAGES_ACTIONS} from "../iframeIntegration";
import {setIframeIntegrationRequest, setIframeIntegrationResponse} from "../../../actions/iframeIntegrationFunctions";
import {setCItemsAddedToParentCart} from "../../../actions/shoppingCartFunctions";
import {isIframe} from "../../../misc/helpers";
import {cartItemInStock} from "../lookNavigation/lookFunctions2";

const LookLoadingPopup = (props) => {

  const {lookOverlayOpened, setLookOverlayOpened, iframeIntegrationRequestType, iframeIntegrationResponseSuccess,
    iframeIntegrationResponse, setIframeIntegrationRequest, setIframeIntegrationResponse, loginPostMessage,
    setCItemsAddedToParentCart, cartItems, fabricatorData} = props;

  let hideFunction = (callBack) => callBack ? callBack() : null;

  const closePopup = () => {
    hideFunction(() => {
      setLookOverlayOpened("");
    })
  }

  useEffect(() => {
    if ((iframeIntegrationRequestType === GROHE_POST_MESSAGES_ACTIONS.addToCart)
      && (typeof iframeIntegrationResponseSuccess == "boolean")) {
      setIframeIntegrationRequest({});
      setIframeIntegrationResponse({});
      window.postMessageIsExecuting = false;
      if (!iframeIntegrationResponseSuccess) {
        if (iframeIntegrationResponse["ErrorCode"] === "ADDTOCART-011") {
          loginPostMessage(true);
        } else {
          renderErrorPopup(iframeIntegrationResponse["ErrorMessage"]);
        }
      }
      setCItemsAddedToParentCart(cartItems.filter(cartItem => cartItemInStock(cartItem)));
      closePopup();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iframeIntegrationRequestType, iframeIntegrationResponseSuccess])

  const questionPopups = [
    LOOK_OVERLAYS.loadingCart
  ];

  if (IS_PRODUCT_JOURNEY || !lookOverlayOpened || !questionPopups.some(popupType => popupType === lookOverlayOpened)) {
    return null
  }

  const getTitle = () => {
    switch (lookOverlayOpened) {
      case LOOK_OVERLAYS.loadingCart: {
        return "loadingCart.title"
      }
    }
    return ""
  }

  const getDescription = () => {
    switch (lookOverlayOpened) {
      case LOOK_OVERLAYS.loadingCart: {
        const isLixil = isIframe() && fabricatorData.isLixil;
        if (isLixil) {
          return "loadingCart.text"
        }
        return document.kvConfig.jobId ? "loadingCart.textQuoteUpdating" : "loadingCart.textQuoteCreating"
      }
    }
    return ""
  }

  return (
    <WithOverlay>
      {(hideOverlay) => {
        hideFunction = hideOverlay;
        return (
          <div className="look-popup look-popup--question look-popup--loading">
            <div className="look-popup__content">
              <h2 className="h2 h2--regular text-left">
                <FormattedMessage id={getTitle(closePopup)}/>
              </h2>
              <p className="text text-left">
                <FormattedMessage id={getDescription()}/>
              </p>
            </div>
            <LookLoadingBar/>
          </div>
        )
      }}
    </WithOverlay>
  )
};

const mapStateToProps = (store) => {
  const {lookOverlayOpened} = store.lookState;
  const {iframeIntegrationRequest, iframeIntegrationResponse} = store.iframeIntegrationState;
  const {cartItems} = store.cartState;
  const fabricatorData = store.fabricatorState;

  return {
    lookOverlayOpened,
    iframeIntegrationRequestType: iframeIntegrationRequest["EventType"],
    iframeIntegrationResponseSuccess: iframeIntegrationResponse["Success"],
    iframeIntegrationResponse,
    cartItems,
    fabricatorData,
  };
};

const mapDispatchToProps = {
  setIframeIntegrationRequest,
  setIframeIntegrationResponse,
  setLookOverlayOpened,
  setCItemsAddedToParentCart,
};

export default withRouter(
  injectIntl(connect(mapStateToProps, mapDispatchToProps)(LookLoadingPopup))
)
